import moment from 'moment';
import React from 'react';
import { GroupedRenderedActions } from 'selectors/envelopes';
import EnvelopeSessionItem from './EnvelopeSessionItem';

type EnvelopeYearLogListProps = {
  year: string;
  sessions: GroupedRenderedActions[];
  includeSentMessage?: boolean;
};

const EnvelopeYearLogList: React.FC<EnvelopeYearLogListProps> = (props) => {
  const { year, sessions, includeSentMessage = false } = props;

  return (
    <div key={year} className="pb-6 relative w-full flex flex-col">
      <div
        className="sticky w-full py-1 flex flex-row justify-center bg-litlingo-gray-1 text-small z-10"
        style={{ top: 0 }}
      >
        <p className="font-bold">{year}</p>
      </div>
      <div className="relative pl-12">
        <div className="flex flex-col gap-3 border-l-2 border-litlingo-gray-2 pt-6 pl-3.5 pr-4">
          {sessions.map((session, idx) => {
            let previousSession = null;

            if (idx !== 0) {
              previousSession = sessions[idx - 1];
            }

            const previousDate = moment(previousSession?.actions[0].created_at);
            const curDate = moment(session?.actions[0].created_at);

            const renderDate =
              previousDate.day() !== curDate.day() || previousDate.month() !== curDate.month();

            return (
              <EnvelopeSessionItem
                key={session.actions[0].created_at}
                index={idx}
                session={session}
                shouldRenderDate={renderDate}
                includeSentMessage={includeSentMessage && idx === sessions.length - 1}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EnvelopeYearLogList;
